import MaterialService from '_services/rest/modules/material';

export default {
  state: {
    materialList: null,
    materialEdit: null,
  },
  mutations: {
    setMaterial(state, response) {
      state.materialEdit = response;
    },
    setMaterialList(state, response) {
      state.materialList = response;
    },
  },
  actions: {
    getMaterialList({ commit }, params) {
      return MaterialService.getList(params)
        .then(response => {
          commit('setMaterialList', response);
        });
    },

    getMaterial({ commit }, params) {
      return MaterialService.getMaterialById(params)
        .then(response => {
          commit('setMaterial', response);
          return response;
        });
    },
  },
};
